const AUTH_FAILURE_MARKERS = [
    'authentication',
    'unauthorized',
    'invalid_token',
    'invalid token',
];

function readStatusCode(value) {
    if (!value || typeof value !== 'object') {
        return;
    }

    const record = value;
    const candidates = [record.status, record.statusCode];

    if (record.response && typeof record.response === 'object') {
        const response = record.response;

        candidates.push(response.status, response.statusCode);
    }

    for (const candidate of candidates) {
        if (typeof candidate === 'number') {
            return candidate;
        }

        if (typeof candidate === 'string' && candidate.trim() !== '') {
            const parsed = Number.parseInt(candidate, 10);

            if (!Number.isNaN(parsed)) {
                return parsed;
            }
        }
    }

    return;
}

function readErrorCode(value) {
    if (!value || typeof value !== 'object') {
        return '';
    }

    const record = value;
    const data =
        record.data && typeof record.data === 'object' ? record.data : null;

    const candidates = [record.error, record.code, data?.error, data?.code];

    for (const candidate of candidates) {
        if (typeof candidate === 'string') {
            return candidate.toLowerCase();
        }
    }

    return '';
}

function readExceptionText(exception) {
    if (!exception) {
        return '';
    }

    if (typeof exception === 'string') {
        return exception.toLowerCase();
    }

    if (typeof exception === 'object') {
        const record = exception;
        const parts = [record.message, record.url, record.path]
            .filter(value => typeof value === 'string')
            .map(value => String(value).toLowerCase());

        if (parts.length > 0) {
            return parts.join(' ');
        }
    }

    return String(exception).toLowerCase();
}

function isAuthenticationFailure(exception) {
    if (!exception) {
        return false;
    }

    const status = readStatusCode(exception);

    if (status === 401 || status === 403) {
        return true;
    }

    const errorCode = readErrorCode(exception);

    if (errorCode === 'invalid_token' || errorCode === 'unauthorized') {
        return true;
    }

    const message = readExceptionText(exception);

    return AUTH_FAILURE_MARKERS.some(marker => message.includes(marker));
}

function getAuthenticationFailureReason(exception) {
    const status = readStatusCode(exception);
    const message = readExceptionText(exception);

    if (
        status === 401 &&
        (message.includes('chronic_care') ||
            message.includes('chronic care') ||
            message.includes('/sso'))
    ) {
        return 'sso_unauthorized';
    }

    if (status === 401) {
        return 'session_expired';
    }

    return 'authentication';
}

export {getAuthenticationFailureReason, isAuthenticationFailure};
